window.jQuery = window.$ = require('jquery');
var processInclude = require('base_cln/util');
$(document).ready(function () {
    processInclude(require('base_cln/components/menu'));
    processInclude(require('base_cln/components/readMore'));
    processInclude(require('base/components/cookie'));
    processInclude(require('./components/policyConsent'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/closeOverlay'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base_cln/components/ellipses.js'));
    processInclude(require('base_cln/components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('base_cln/components/header.js'));
    processInclude(require('base_cln/components/faq.js'));
    processInclude(require('base_cln/product/productCarousel.js'));
    processInclude(require('base_cln/components/eolMessage'));
    $('body').on("click", ".Ikp-checkbox", function (evt) { 
        if ($(this).find('input').prop('checked')) { 
            $(this).closest('.agree-Ikp').find('a').removeClass('disabled');
        } else {
         $(this).closest('.agree-Ikp').find('a').addClass('disabled')
        }
      })
});

require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/collapse.js');
require('base_cln/thirdParty/slick.js');
require('base/components/spinner');


